import React, { useCallback, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const LetterLoading = () => {
  const [completedAnimations, setCompletedAnimations] = useState({
    logo: false,
    cover: false,
  });

  const shouldExit = completedAnimations.logo && completedAnimations.cover;

  const handleAnimationComplete = useCallback(
    (animationType: 'logo' | 'cover') => {
      console.log('handleAnimationComplete', animationType);

      setCompletedAnimations((prev) => {
        const newState = {
          ...prev,
          [animationType]: true,
        };

        return newState;
      });
    },
    []
  );

  return (
    <AnimatePresence>
      {!shouldExit && (
        <motion.div
          className='p-loading'
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
          onAnimationComplete={(definition) => {
            if (definition === 'exit') {
              const target = document.querySelector('.p-loading');
              if (target instanceof HTMLElement) {
                target.style.display = 'none';
              }
            }
          }}
        >
          <div className='p-loading__inner'>
            <motion.div
              className='p-loading__cover'
              initial={{ rotateX: 0 }}
              animate={{ rotateX: 120 }}
              transition={{
                duration: 1.2,
                ease: 'easeInOut',
                delay: 1.0,
              }}
              onAnimationComplete={() => handleAnimationComplete('cover')}
            >
              <img src='/img/common/logo.png' alt='SKALE' />
            </motion.div>

            <motion.div
              className='p-loading__text'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{
                duration: 0.5,
                ease: 'easeInOut',
                delay: 0.5,
              }}
              onAnimationComplete={() => handleAnimationComplete('logo')}
            >
              たった1つの
              <br />
              メッセージ
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LetterLoading;
